import { render } from "./SaleModal.vue?vue&type=template&id=3dfb79db&scoped=true"
import script from "./SaleModal.vue?vue&type=script&lang=ts"
export * from "./SaleModal.vue?vue&type=script&lang=ts"

import "./SaleModal.vue?vue&type=style&index=0&id=3dfb79db&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3dfb79db"

export default script